<template>
  <div class="text-center">
    <v-menu
      offset-y
      :close-on-content-click="false"
      :close-on-click="closeOnClick"
      v-model="value"
      min-width="120px"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          v-on="on"
          text
          icon
          class="drowdown-btn"
        >
          <v-icon x-small>fa fa-ellipsis-h</v-icon>
        </v-btn>
      </template>
      <v-list
        dense
        class="list-menu-company"
      >
        <v-list-item
          v-for="(item, index) in getItems"
          :key="index"
        >
            <v-list-item-content v-if="item.code == 'E'" class="pt-0 pb-0">
              <companyDetailWindow
                title="Company Info."
                :btnTxt="item.content"
                :btnIcon="item.icon"
                :dataValue="getDataValue"
                disable-close="disableClose()"
                @enable-close="enableClose()"
                @refreshList="refreshList"
              >
              </companyDetailWindow>
            </v-list-item-content>
            <v-list-item-content v-else-if="item.code == 'D'" class="pt-0 pb-0">
              <dialogWindow
                title="Company Remove"
                size="max"
                :btnTxt="item.content"
                :btnIcon="item.icon"
                :info="getDataValue.compNm"
                detail="Would you like remove this company?"
                :dataValue="getDataValue"
                color="confirmation"
                :showCancel="true"
                @select-ok="okEvent($event, item.code)"
                @disable-close="disableClose()"
                @enable-close="enableClose()"
              >
              </dialogWindow>
            </v-list-item-content>
            <v-list-item-content v-if="item.code == 'A'" class="pt-0 pb-0">
              <companyAgentDropdown
                title="Company Agent"
                :btnTxt="item.content"
                :btnIcon="item.icon"
                :companyValue="getDataValue"
                @refreshList="refreshList" 
              >
              </companyAgentDropdown>
            </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>


<script>
import dialogWindow from '@/vue-caas/views/company/CompanyDeleteDialog.vue'
import companyDetailWindow from '@/vue-caas/views/company/CompanyDetail.vue'
import companyAgentDropdown from '@/vue-caas/views/company/CompanyAgentList.vue'

export default {
  components: {
    dialogWindow,
    companyDetailWindow,
    companyAgentDropdown,
  },
  props: {
    items: {
      default: [
        { content: 'Modify', icon: 'fa fa-edit', code: "E" },
        { content: 'Remove', icon: 'fa fa-trash-alt', code: "D"  },
        { content: 'Agent', icon: 'fa fa-database', code: "A" },
      ]
    },
    dataValue: {
      default: Object
    },
  },
  data() {
    return {
      value: false,
      closeOnClick: true,
    }
  },
  computed: {
      getItems() {
          return this.items;
      },
      getDataValue() {
        return this.dataValue;
      }
  },
  methods: {
      okEvent(item, code) {
          let result = Object;
          result.value = item;
          result.code = code;
          this.$emit("click-event", result);
          this.value = false;
      },

      disableClose() {
        this.value = false;
        this.closeOnClick = false;
        this.$emit('disable-close');
      },

      enableClose() {
        this.closeOnClick = true;
        this.$emit('enable-close');
      },
      refreshList(){
        this.$emit('refreshList');
      }
  },
}
</script>
<style>
.theme--dark .list-menu-company{
  background: #373B46 ;
}
.drowdown-btn{
  height:22px !important;
  width:22px !important;
}
</style>